var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GChart',{staticStyle:{"height":"150px","width":"100% !important"},attrs:{"type":"LineChart","data":_vm.speedChartData,"options":_vm.speedChartOptions},on:{"ready":_vm.drawGraph}})
}
var staticRenderFns = []

export { render, staticRenderFns }